module.exports = __webpack_public_path__ + "static/background-two-ea364359e2dd7f657d251bae292eab6b.png";